import React, { useState, useEffect } from "react"
import { IAccessControlSettings } from "../../../../store/api/admin/types"
import { initialState } from "../../../../store/api/admin/initialState"
import { useGetAccessControlSettingsQuery, useUpdateAccessControlSettingsMutation } from "../../../../store/api/admin/adminApiSlice";
import { useStoreDispatch } from "../../../../store/hooks";
import { setErrorMsg, setOpenToast } from "../../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../../store/helpers/helperSelectors";
import { useSelector } from "react-redux";
import { convertSettingsToSystemProperties, convertSystemPropertiesToSettings } from "../../helpers";
import { setAccessControlSettings } from "../../../../store/api/admin/reducers";
import { store } from "../../../../store";
import { IKeyValue } from "../../types";



export const useAccessControlSettingsForm = () => {
    const dispatch = useStoreDispatch();
    const[formData, setFormData] = useState<IAccessControlSettings>(initialState.accessControlSettings);
    const [ updateSettings, {isLoading}] = useUpdateAccessControlSettingsMutation();
    const {data, refetch} = useGetAccessControlSettingsQuery(); 
    const minimumAgeDays = "minimumAgeDays";
    const expiryWarningDays = "expiryWarningDays";
    const minimumLength = "minimumLength";

    const reusePreventionCount = "reusePreventionCount"
    const reusePreventionDays = "reusePreventionDays"
    const accountLockoutFailedCount = "accountLockoutFailedCount"
    const inactivityLogoutDurationMinutes = "inactivityLogoutDurationMinutes"
    const bannerTitle = "bannerTitle"
    const messageOfDay = "messageOfDay"

    const errorMsg = useSelector(errorMsgSelector)
    const clearInputList={minimumAgeDays:"", expiryWarningDays:"", minimumLength:"",reusePreventionCount:"",reusePreventionDays:"", accountLockoutFailedCount:"",inactivityLogoutDurationMinutes:"",bannerTitle:"",messageOfDay:""}
    
    useEffect(() => {
        dispatch(setErrorMsg({...errorMsg, ...clearInputList }));
        setFormData(convertSystemPropertiesToSettings(data));
    }, [data]);

   const cancelHandler = () => {
        dispatch(setErrorMsg({...errorMsg, ...clearInputList }));
        setFormData(convertSystemPropertiesToSettings({ ...data }));
    }

       const submitHandler = async (event?: React.FormEvent) => {
            event?.preventDefault();
            if (errorsPresent) {
                return false;
            }

            const payload = convertSettingsToSystemProperties(formData);
            const result: any = await updateSettings(payload);
            if (result?.error) throw result?.error?.message;
            if (result.data?.status === 200) {
                refetch();
                dispatch(setAccessControlSettings({ ...formData }));
                dispatch(setOpenToast({ openToast: true, toastType: "success", message: "Access Control Settings updated successfully." }));
                return true;
            }

            return false;
        };

    const handleDisabled = (name: string, defaultValue: any | undefined) => {
       setFormData((prev) => ({ ...prev, [name]: defaultValue }));
       const existingErrorMsg = store.getState().helpers.errorMsg;
       dispatch(setErrorMsg({ ...existingErrorMsg, [name]: "" }));
    };

    const onMinAgeOrWarningDaysBlurHandler = (event: any) => {
        const { name, value } = event.target;
        let error = "";
        if(name == minimumAgeDays){            
            let minAgeValue = Math.max(1, formData.expiryWarningDays);
            if(value < minAgeValue || value > 120 ){
                error = `Value must be between ${minAgeValue} and 120`;
                dispatch(setErrorMsg({ ...errorMsg, [name] : error}));
            }
        }

        if(name == expiryWarningDays){
            let maxWarningDaysValue = Math.min(120, formData.minimumAgeDays);
            if(value < 1 || value > maxWarningDaysValue){
                error = `Value must be between 1 and ${maxWarningDaysValue}`;
                dispatch(setErrorMsg({ ...errorMsg, [name] : error}));
            }
        }

        if(error == ""){
            dispatch(setErrorMsg({ ...errorMsg, [minimumAgeDays] : "", [expiryWarningDays] : ""}));
        }
    };

    const keys = [minimumAgeDays, expiryWarningDays, minimumLength, reusePreventionCount, reusePreventionDays, accountLockoutFailedCount, inactivityLogoutDurationMinutes, bannerTitle, messageOfDay];
    const errorMsglist = keys.reduce((acc : IKeyValue, k) => {
        acc[k] = errorMsg[k] ?? ''; 
        return acc;
    }, {});
    
    const errorsPresent = Object.values(errorMsglist).some((err) => err !== "");
    return{
        formData,
        setFormData,
        cancelHandler,
        submitHandler,
        isLoading,
        minimumAgeDays,
        expiryWarningDays,
        minimumLength,
        reusePreventionCount,
        reusePreventionDays,
        accountLockoutFailedCount,
        inactivityLogoutDurationMinutes,
        bannerTitle,
        messageOfDay,
        errorsPresent,
        handleDisabled,
        onMinAgeOrWarningDaysBlurHandler
    };
}